import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { I18nProvider } from "@/context/I18nContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ChatApp from "@/pages/ChatApp";
import JoinChannel from "@/pages/JoinChannel";
import SharePreview from "@/pages/SharePreview";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--rc-bg)]">
        <div className="h-10 w-10 rounded-full border-2 border-[var(--rc-gold)] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AuthGate({ mode }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (user) return <Navigate to="/app" replace />;
  return <Auth mode={mode} />;
}

export default function App() {
  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" theme="dark" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<AuthGate mode="login" />} />
              <Route path="/register" element={<AuthGate mode="register" />} />
              <Route path="/app/*" element={<Protected><ChatApp /></Protected>} />
              <Route path="/p/:id" element={<SharePreview kind="product" />} />
              <Route path="/post/:id" element={<SharePreview kind="post" />} />
              <Route path="/join/:code" element={<JoinChannel />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}
